import { createContext, useContext, useEffect } from 'react'
import { applyNoContactEmailConfig } from 'src/shared/patient/noContactEmail'
import { AppConfigContext } from './AppConfigContext'

// Default context value to prevent undefined errors
const defaultContextValue = {
  unSecureSetupLoading: false,
  unSecureSetupData: null,
  unSecureSetupError: null,
}

export const UnsecureSetupContext = createContext(defaultContextValue)

export const UnsecureSetupContextProvider = ({ children }) => {
  // Read from AppConfigContext instead of making API call
  const appConfig = useContext(AppConfigContext)
  const setupData = appConfig?.setup?.data ?? null

  // Module-level config for helpers that run outside React (e.g. the create-patient call).
  useEffect(() => {
    applyNoContactEmailConfig(setupData)
  }, [setupData])

  return (
    <UnsecureSetupContext.Provider
      value={{
        unSecureSetupLoading: appConfig?.setup?.loading ?? false,
        unSecureSetupData: appConfig?.setup?.data ?? null,
        unSecureSetupError: appConfig?.setup?.error ?? null,
      }}
    >
      {children}
    </UnsecureSetupContext.Provider>
  )
}
